import { createBrowserRouter } from "react-router-dom";
import Mainlayout from "../Layouts/Mainlayout";
import ErrorPage from "../pages/ErrorPage";
import Homepage from "../pages/Homepage/Homepage";
import LoginPage from "../pages/AuthenticationPage/LoginPage";
import RegisterPage from "../pages/AuthenticationPage/RegisterPage";
import ProductDetails from "../pages/ProductDetailsPages/ProductDetails";
import AgentProductPage from "../pages/AgentProductListPage/AgentProductPage";
import PrivateRoute from "./PrivateRoute";
import ProductCheckOut from "../pages/ProductDetailsPages/ProductCheckOut";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Mainlayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Homepage />,
      },
      {
        path: "/agent-add-product",
        element: (
          <PrivateRoute allowedTypes={["agent"]}>
            <AgentProductPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/product/:id",
        element: <ProductDetails />,
      },
      {
        path: "/checkout",
        element: <ProductCheckOut />,
      },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/signUp",
    element: <RegisterPage />,
  },
]);

export default router;
